import { LoadableLazy } from '@confluence/loadable';

export const FloatingNoteLayout = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FloatingNote" */ '../src/FloatingNoteLayout.tsx'))
			.FloatingNoteLayout,
});
